import { useAuth } from '@deltasuite/auth';
import { useEffect, type ReactNode } from 'react';
import { setAccessTokenProvider } from '../api/client';

// Connects useAuth().getAccessToken to api/client's module-level fetch
// wrapper. Mounted once, immediately under <AuthProvider/>. Children render
// straight through.
export function AuthBridge({ children }: { children: ReactNode }) {
  const { getAccessToken } = useAuth();
  useEffect(() => {
    setAccessTokenProvider(getAccessToken);
    return () => setAccessTokenProvider(null);
  }, [getAccessToken]);
  return <>{children}</>;
}
